<header class="flex items-center justify-between border-b border-border px-4 py-3">
  <h1 class="text-lg font-semibold">msngr</h1>
  <nav class="flex items-center gap-2 text-sm text-muted-foreground">
    <a routerLink="/">Messenger</a>
    <span>|</span>
    <a routerLink="/auth-demo">Auth demo</a>
    <span>|</span>
    <a routerLink="/auth-demo/protected">Protected</a>
    <span>|</span>
    <a routerLink="/ui-kit">UI Kit</a>
  </nav>
</header>
<main class="p-4">
  <router-outlet></router-outlet>
</main>
